// External Libraries
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
// Custom HOCs
import WithRouter from 'custom/withRouter';
// Constants
import LOOKUP from 'constants/lookup';
// Actions
import { formInput, clearFormInput } from 'actions/FormActions';
import { getDeliveryReport, getCsvReport } from 'actions/ReportsAction';
// Utils
import { reportDeliveryReportCrumb } from 'utils/breadcrumbInfo';
// Basic Components
import CardSimple from 'screens/components/basic/CardSimple';
import Grid from 'screens/components/basic/Grid';
import PageHeader from 'screens/components/basic/PageHeader';
import Pagination from 'screens/components/basic/Pagination';
// Local Components
import Body from './Body';
import Header from './Header';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';

class DeliveryReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                selectedDate: 0,
                branch: 0
            }
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), date.getDate()),
            `DeliveryReportSelectedDate`);
    }

    downloadReport = () => {
        let selectedDate = this.props.selectedDate ? moment(this.props.selectedDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;

        this.props.getCsvReport(`reports/excel/delivery?branch=${branch}&date=${selectedDate}`, "deliveryReport");
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    getReport = () => {
        let selectedDate = this.props.selectedDate ? moment(this.props.selectedDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        this.props.getDeliveryReport({ branch, selectedDate, pageNumber, pageSize });
    }

    showBody() {
        this.filter();
        this.setState({ showBody: true });
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    componentWillReceiveProps = (newProps) => {
        if (this.state.showBody) {
            const totalRow = newProps.deliveryReport && newProps.deliveryReport.list && newProps.deliveryReport.list.length > 0 ? newProps.deliveryReport.total : 0;
            this.setState({ totalRow: totalRow })
        }
    }

    render() {

        return (
            <Grid headerContent={reportDeliveryReportCrumb}>
                <PageHeader title={LOOKUP.report.deliveryReport.text}
                    description={LOOKUP.report.deliveryReport.description}
                />
                <Header
                    branchOptions={this.props.brachOptions}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                />
                {
                    this.state.showBody && this.props.deliveryReport &&
                    <React.Fragment>
                        <DateCurrentDisplay />
                        <CardSimple>
                            <Body
                                deliveryReport={this.props.deliveryReport}
                                selectedDate={this.props.selectedDate}
                                loggedBranch={this.props.loggedBranch}
                                branchForm={this.props.branch}
                            />
                            <Pagination
                                length={this.state.totalRow}
                                itemsPerPage={this.state.itemsPerPage}
                                activePage={this.state.activePage}
                                onPageChange={this.changePage}
                            />
                        </CardSimple>
                    </React.Fragment>
                    
                }
            </Grid>
        );
    }

}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        deliveryReport: state.reports.deliveryReport,
        loggedBranch: state.common.branchId,
        selectedDate: state.form.DeliveryReportSelectedDate,
        branch: state.form.DeliveryReportBranchOption
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getDeliveryReport: model => dispatch(getDeliveryReport(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(DeliveryReport));